import React, {useEffect, useMemo, useState} from "react";
import {getDateFromISOString} from "../../../../../utils/getAge";
import {laborantService} from "../../../../../api/laborantService";
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import classes from './form.module.scss';
import classNames from 'classnames';
import errorMessage from "../../../../../const/Tost";
import EditableField from "./EditableFiled";
import {DirectionService} from "../../../../../api/directionService";
import {contractService} from "../../../../../api/contractService";

const ReferralCardEdit = () => {
        const {id} = useParams();
        const navigate = useNavigate();

        const {
            register,
            formState: {errors},
            handleSubmit,
            control,
            setValue,
            watch
        } = useForm();

        const year = watch("ageYears");
        const month = watch("ageMonths");
        const day = watch("ageDays");

        const regForm = useSelector(state => state.regForm);

        const values = useMemo(() => ({
            ...regForm,
            fields: [
                ...regForm.fields?.filter((e) => e.legend !== 'Антитіла'),
                {
                    legend: 'Відділення закладу',
                    id: 20,
                    type: 'text',
                    required: true,
                    name: 'externalDepartmentId',
                    dataType: 'directionData',
                    options: true,
                    props: []
                }, {
                    legend: 'Антитіла',
                    id: 22,
                    type: 'text',
                    required: true,
                    name: 'antibodies',
                    dataType: 'antibodies',
                    options: true,
                    props: []
                }
            ]
        }), [regForm]);
        const [filteredData, setFilteredData] = useState([]);

        const fetchData = async(id) => {
            const response = await DirectionService.getOptions();
            let clinicDepartment

            if (id){
                const responseByClinic = await contractService.getDepartmentsByClinic(id);
                if (!!responseByClinic?.data){
                    clinicDepartment = responseByClinic?.data.map(el => ({
                        value: el.name,
                        label: el.name,
                        id: el.id,
                        type: 'option'
                    }))
                }
            }

            const antibodies = response?.data?.antibodies.map(el => ({
                value: el.name,
                label: el.name,
                id: el.id,
                type: 'option',
            }))

            const departments = response?.data?.departments.map(el => ({
                value: el.name,
                label: el.name,
                id: el.id,
                type: 'option',
            }))


            return {departments, antibodies, clinicDepartment}
        }

        const fetchContract = async(id) => {
            const response = await DirectionService.getContractForClinic(id)
            if (!!response?.data?.data?.length){

                return response?.data?.data.map(el => ({
                    value: el.name,
                    label: el.name,
                    id: el.id,
                    type: 'option',
                }))
            }
        }

        const onSubmit = async(data) => {
            if (data?.ageYears === '0' && !data?.ageMonths && !data?.ageDays || data?.ageMonths === '0' && !data?.ageDays){
                errorMessage('', 'Вкажіть правильний вік');
            } else {
                const gender = data.gender ? data?.gender : values?.fields?.filter(el => el?.name == "gender");
                const patientInfo = {
                    ...data,
                    ageYears: data?.ageYears && data.ageYears !== '0' ? data.ageYears : null,
                    ageMonths: data?.ageMonths && data.ageMonths !== '0' ? data.ageMonths : null,
                    ageDays: data?.ageDays && data.ageDays !== '0' ? data.ageDays : null,
                    patient: {
                        name: data?.name,
                        lastName: data?.name,
                        middleName: data?.name,
                        gender: data?.gender,
                    }

                }

                await DirectionService.updateDirectionFull(id, patientInfo).then(res => {
                    if (!!res?.data){
                        navigate('/Referrals')
                    }
                })
            }
        }

        useEffect(() => {
            const getMatchedData = async() => {
                try{
                    const matchedData = await laborantService.getDirection(id);
                    const { departments, antibodies, clinicDepartment } = await fetchData(matchedData?.data?.hospitalId);

                    let contracts

                    if (matchedData?.data?.contractId){
                        contracts = await fetchContract(matchedData?.data?.hospitalId)
                    }

                    const result = values?.fields
                        ?.sort((a, b) => a.id - b.id)?.map(key => {
                            const item = matchedData?.data?.[key?.name] || matchedData?.data?.patient?.[key?.name];
                            const editableFields = ["activeDoc", "clinicalConclusion", "clinicalInfo", "operationName", "lastName", "name", "middleName", "ageYears", "ageMonths", "gender", "ageDays", 'markedMaterial'];

                            if (item){
                                if (key?.name === "antibodies"){
                                    return item.length && {...key, value: item?.map(e => ({ ...e, value: e.name })), props: antibodies, show: true, canBeEdited: true};
                                } else if (key?.name === "operationDate"){
                                    return {...key, value: getDateFromISOString(item), show: true, canBeEdited: true};
                                } else if (key?.name === "contractId"){
                                    return {
                                        ...key,
                                        type: "text",
                                        value: matchedData?.data?.contract?.name,
                                        props: contracts,
                                        show: true,
                                        canBeEdited: true
                                    };
                                } else if (key?.name === "hospitalId"){
                                    return {...key, type: "text", value: matchedData?.data?.hospital?.name, show: true};
                                } else if (key?.name === "externalDepartmentId"){
                                    return {
                                        ...key,
                                        type: "text",
                                        value: matchedData?.data?.externalDepartment?.name,
                                        props: clinicDepartment,
                                        show: true,
                                        canBeEdited: true
                                    };
                                } else if (key?.name === "departmentId"){
                                    return {
                                        ...key,
                                        type: "text",
                                        value: matchedData?.data?.department?.name,
                                        props: departments,
                                        canBeEdited: true,
                                        show: true
                                    };
                                } else if (key?.name === "markedMaterial"){
                                    return {...key, type: "text", value: matchedData?.data?.markedMaterial, show: true, canBeEdited: true};
                                } else if (key?.name === "biopsy"){
                                    return {...key, type: "text", value: item, show: true, canBeEdited: true};
                                } else if (key?.name === "phoneNumber"){
                                    return {...key, type: "text", value: item, defaultValue: item, show: true};
                                } else if (editableFields.includes(key?.name)){
                                    return {...key, value: item, show: true, canBeEdited: true};
                                } else {
                                    return {...key, value: item, show: true};
                                }
                            } else {
                                if (key?.name === "birthDate"){
                                    return {
                                        ...key,
                                        props: key?.props?.map(e => (matchedData?.data[e?.name] ? {
                                            ...e,
                                            defaultValue: matchedData?.data[e?.name],
                                            show: false
                                        } : {
                                            ...e,
                                            show: true,
                                            defaultValue: 0
                                        })),
                                        canBeEdited: true
                                    }
                                }
                            }
                        });
                    setFilteredData(result?.filter(e => e));
                } catch(error){
                    console.log(error)
                    errorMessage('Error fetching matched data:', error?.response?.data);
                }
            };

            getMatchedData();
        }, [id, values]);

        useEffect(() => {
            const monthInput = document.querySelector('[name="ageMonths"]');
            const dayInput = document.querySelector('[name="ageDays"]');

            if (year == '0'){
                monthInput.disabled = false;
                dayInput.disabled = true;
            } else if (year > 0 || year == ''){
                setValue("ageMonths", '');
                setValue("ageDays", '');
                monthInput.disabled = true;
                dayInput.disabled = true;
            }

            setValue("ageYears", removeLeadingZeros(year));
        }, [year, setValue]);


        useEffect(() => {
            const dayInput = document.querySelector('[name="ageDays"]');
            const yearInput = document.querySelector('[name="ageYears"]');

            if (month == '0'){
                dayInput.disabled = false;
                yearInput.disabled = false;
            } else if (month > 0 || month == ''){
                setValue("ageDays", '');   // Сброс значения дня
                dayInput.disabled = true;
                yearInput.disabled = true;
            }

            setValue("ageMonths", removeLeadingZeros(month));
        }, [month, setValue]);

        useEffect(() => {
            const dayInput = document.querySelector('[name="ageDays"]');
            const yearInput = document.querySelector('[name="ageYears"]');

            if (month == '0'){
                dayInput.disabled = false;
                yearInput.disabled = false;
            } else if (month > 0 || month == ''){
                setValue("ageDays", '');   // Сброс значения дня
                dayInput.disabled = true;
                yearInput.disabled = true;
            }

            setValue("ageMonths", removeLeadingZeros(month));
        }, [month, setValue]);


        useEffect(() => {
            const yearInput = document.querySelector('[name="ageYears"]');
            const monthInput = document.querySelector('[name="ageYears"]');

            if (day == '0'){
                monthInput.disabled = false;
                yearInput.disabled = false;
            } else if (+day > 0 || day == ''){
                setValue("ageYears", '');   // Сброс значения дня
                setValue("ageMonths", '');   // Сброс значения дня
                yearInput.disabled = true;
                monthInput.disabled = true;
            }

            setValue("ageMonths", removeLeadingZeros(month));
        }, [day, setValue]);

        const removeLeadingZeros = (value) => {
            if (value && value.length > 1){
                return value.replace(/^0+/, '');
            }
            return value;
        };

        return (
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                {<h2 style={{
                    maxWidth: "600px",
                    textAlign: "center",
                    marginBottom: 0,
                }}>Оновити скерування</h2>}

                {filteredData?.map((el, index) => (
                    <div className={classes[values.class]} key={index}>
                        <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>
                        <div className={classNames(classes.form__label__container, {[classes.cassets__container]: el.name === 'cassets'})}>
                            <EditableField el={el} errors={errors} register={register} control={control} classes={classes}/>
                        </div>
                    </div>
                ))}

                <button className={classes.form__button} type='submit'>
                    Змінити
                </button>
            </form>
        );
    }
;

export default ReferralCardEdit;
